import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    const scannerToken = localStorage.getItem('scannerToken');
    
    // Prefer admin token, then scanner token
    const token = adminToken || scannerToken;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only clear admin tokens — this is the admin API instance
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminData');

      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Scanner-specific API instance
export const scannerApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

scannerApi.interceptors.request.use(
  (config) => {
    const scannerToken = localStorage.getItem('scannerToken');
    if (scannerToken) {
      config.headers.Authorization = `Bearer ${scannerToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

scannerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only clear scanner tokens — this is the scanner API instance
      localStorage.removeItem('scannerToken');
      localStorage.removeItem('scannerData');

      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/scanner';
      }
    }
    return Promise.reject(error);
  }
);

// Public API instance — no auth interceptors, for unauthenticated public pages
export const publicApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});
